import request from '@/api'

// API文档 发起调用
export async function getInformationList(data) {
  return request({
    url: '/capi/content-management/content/list2C',
    method: 'post',
    data
  })
}

// 查询单个api内容详情
export async function getInformationItem(data) {
  return request({
    url: `/capi/content-management/content/get2C`,
    method: 'get',
    params: data
  })
}

// 查询单个api内容详情
export async function get2CByGroupId(data) {
  return request({
    url: `/capi/content-management/content/get2CByGroupId`,
    method: 'get',
    params: data
  })
}
// 获取学堂标签组
export async function getTags(data) {
  return request({
    url: `/capi/label/v1/tag/batchQuery`,
    method: 'post',
    data
  })
}
